import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-weather.md.
export const Route = createFileRoute('/_app/weather')({
  component: WeatherPage,
});

function WeatherPage() {
  return <ComingSoon slug="weather" />;
}
